import { render, staticRenderFns } from "./RepoGradoPage.vue?vue&type=template&id=553e8017"
import script from "./RepoGradoPage.js?vue&type=script&lang=js&external"
export * from "./RepoGradoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports